import { Component} from '@angular/core';


@Component({
  selector: 'app-optical-side-panel',
  templateUrl: './optical-side-panel.component.html',
  styleUrls: ['./optical-side-panel.component.scss']
})
export class OpticalSidePanelComponent {
 
}
